import {
  SORT_TYPES,
  TEAM_INVITES_TABLE_COLUMN_HEADERS,
} from '../../../constants'
import { StandardCompare } from '../../../containers/Utilities'
import { getYearMonthDateFormat } from 'common/dateUtils'

export const sortTeamInvitesIds = (
  sorts = {
    sortBy: TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL,
    sortDirection: SORT_TYPES.ASC,
  },
  invIds = [],
  teamInvitesById = {},
) => {
  const {
    sortBy,
    sortDirection,
  } = sorts
  const teamInvitesIds = [ ...invIds ]
  let sortedTeamInvitesIds = teamInvitesIds

  if (teamInvitesIds) {
    switch (sortBy) {
    case TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL:
      sortedTeamInvitesIds = teamInvitesIds.sort((a, b) => StandardCompare.strings(teamInvitesById[a].email, teamInvitesById[b].email, sortDirection))
      break
    case TEAM_INVITES_TABLE_COLUMN_HEADERS.FIRSTNAME:
      sortedTeamInvitesIds = teamInvitesIds.sort((a, b) => StandardCompare.strings(teamInvitesById[a].firstName, teamInvitesById[b].firstName, sortDirection))
      break
    case TEAM_INVITES_TABLE_COLUMN_HEADERS.LASTNAME:
      sortedTeamInvitesIds = teamInvitesIds.sort((a, b) => StandardCompare.strings(teamInvitesById[a].lastName, teamInvitesById[b].lastName, sortDirection))
      break
    case TEAM_INVITES_TABLE_COLUMN_HEADERS.DATE:
      sortedTeamInvitesIds = teamInvitesIds.sort((a, b) => StandardCompare.dates(getYearMonthDateFormat(teamInvitesById[a].createdAt), getYearMonthDateFormat(teamInvitesById[b].createdAt), sortDirection))
      break
    default:
      // No sort, keep previous sort
      break
    }
  }

  return sortedTeamInvitesIds
}

export const filterTeamInvitesIds = (
  filters = {
    selectedEmail: undefined,
  },
  teamInvitesIds = [],
  teamInvitesById = {},
) => {
  const {
    selectedEmail,
  } = filters
  let filteredTeamInvitesIds = teamInvitesIds

  if (teamInvitesIds) {
    filteredTeamInvitesIds = teamInvitesIds
      .filter(id => {
        if (!selectedEmail) {
          return true
        }
        const invite = teamInvitesById[id]
        const text = invite.email || ''
        return text.includes(selectedEmail)
      })
  }

  return filteredTeamInvitesIds
}



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/TeamInvitesTable/Utilities.js